export function ReviewsTab() {
  return (
    <>
      <div className="topbar">
        <div>
          <h1>Reviews</h1>
          <div className="sub">Old customers plus jobs you won here. Ask for a Google review from their Telnyx number.</div>
        </div>
      </div>
      <div className="card">
        <div className="empty">
          Two lists will live here: imported backlog and closed LeadsIRL jobs. “Ask for review” sends SMS on their campaign. Auto-checking Google comes later.
        </div>
      </div>
    </>
  );
}
